module.exports = __webpack_public_path__ + "img/check_in-out2.a302064d.png";